var map = {
	"./404.svg": "49be",
	"./bug.svg": "937c",
	"./build.svg": "b88c",
	"./button.svg": "c292",
	"./cascader.svg": "737d",
	"./chart.svg": "20e7",
	"./checkbox.svg": "9ec1",
	"./clipboard.svg": "5aa7",
	"./code.svg": "d7a0",
	"./color.svg": "e218",
	"./component.svg": "02b8",
	"./dashboard.svg": "7154",
	"./date-range.svg": "ad41",
	"./date.svg": "a2bf",
	"./dict.svg": "da75",
	"./documentation.svg": "ed00",
	"./download.svg": "039a",
	"./drag.svg": "a2f6",
	"./druid.svg": "bc7b",
	"./edit.svg": "2fb0",
	"./education.svg": "2369",
	"./email.svg": "caf7",
	"./example.svg": "b6f9",
	"./excel.svg": "e3ff",
	"./exit-fullscreen.svg": "f22e",
	"./eye-open.svg": "74a2",
	"./eye.svg": "57fa",
	"./form.svg": "4576",
	"./fullscreen.svg": "72e5",
	"./github.svg": "cda1",
	"./guide.svg": "72d1",
	"./icon.svg": "9f4c",
	"./input.svg": "0b37",
	"./international.svg": "a601",
	"./job.svg": "e82a",
	"./language.svg": "a17a",
	"./link.svg": "5fda",
	"./list.svg": "3561",
	"./lock.svg": "a012",
	"./log.svg": "9cb5",
	"./logininfor.svg": "9b2c",
	"./message.svg": "15e8",
	"./money.svg": "4955",
	"./monitor.svg": "f71f",
	"./nested.svg": "91be",
	"./number.svg": "a1ac",
	"./online.svg": "575e",
	"./password.svg": "198d",
	"./pdf.svg": "8989",
	"./people.svg": "ae6e",
	"./peoples.svg": "dc13",
	"./phone.svg": "b470",
	"./post.svg": "482c",
	"./qq.svg": "39e1",
	"./question.svg": "5d9e",
	"./radio.svg": "9a4c",
	"./rate.svg": "04ad",
	"./redis.svg": "0c4f",
	"./rich-text.svg": "e7b9",
	"./row.svg": "0c16",
	"./search.svg": "679a",
	"./select.svg": "0ee3",
	"./server.svg": "4738",
	"./shopping.svg": "98ab",
	"./size.svg": "879b",
	"./skill.svg": "a263",
	"./slider.svg": "df36",
	"./star.svg": "4e5a",
	"./swagger.svg": "84e5",
	"./switch.svg": "243e",
	"./system.svg": "922f",
	"./tab.svg": "2723",
	"./table.svg": "dc78",
	"./textarea.svg": "7234",
	"./theme.svg": "7271",
	"./time-range.svg": "99c3",
	"./time.svg": "f8e6",
	"./tool.svg": "06b3",
	"./tree-table.svg": "4d24",
	"./tree.svg": "0e8f",
	"./upload.svg": "068c",
	"./user.svg": "d88a",
	"./validCode.svg": "67bd",
	"./wechat.svg": "2ba1",
	"./zip.svg": "a75d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";